@if(true){
<form [formGroup]="form" class="modal-body" (ngSubmit)="submitForm()">
  <div class="card">
    <div class="card-body">

      <div class="row">
        @if(formData?.length) {
        @for(input of formData; track $index; let i = $index) {

        <!-- Hidden -->
        @if (input.controlType === 'Hidden') {
        <input type="hidden" [formControlName]="input.controlName" />
        }

        <!-- Text -->
        @if (input.controlType === 'TXT') {
        <div class="col-12 col-sm-6 mb-3">
          <label [for]="input.controlName" class="form-label">
            {{ input.captionName }}
          </label>

          <input class="form-control" [id]="input.controlName" type="text" [placeholder]="input.placeholder"
            [formControlName]="input.controlName" />

          @if (hasError(input.controlName)) {
          <div class="text-danger mt-1">
            @if (form.get(input.controlName)?.errors?.required) { Input required }
            @if (form.get(input.controlName)?.errors?.minlength) {
            Minimum length is {{ input.validators?.minlength }}
            }
            @if (form.get(input.controlName)?.errors?.maxlength) {
            Maximum length is {{ input.validators?.maxlength }}
            }
          </div>
          }
        </div>
        }

        <!-- Single Select (SHLP) -->
        @if (input.controlType === 'SHLP') {
        <div class="col-12 col-sm-6 mb-3">
          <label class="form-label">{{ input.captionName }}</label>

          <ng-select [items]="input.Options || []" bindLabel="optionName" bindValue="value"
            [formControlName]="input.controlName" [clearable]="false" [closeOnSelect]="true" [selectableGroup]="true"
            placeholder="Select">
            <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
              {{ item.optionName }}
            </ng-template>
          </ng-select>

          @if (hasError(input.controlName)) {
          <div class="text-danger mt-1">Input required</div>
          }
        </div>
        }

        <!-- Multi Select (HLP) -->
        @if (input.controlType === 'HLP') {
        <div class="col-12 col-sm-6 mb-3">
          <label class="form-label">{{ input.captionName }}</label>

          <ng-select [items]="input.Options || []" bindLabel="optionName" bindValue="value" [multiple]="true"
            [formControlName]="input.controlName" [closeOnSelect]="false" [selectableGroup]="true" placeholder="Select">
            <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
              {{ item.optionName }}
            </ng-template>
          </ng-select>

          @if (hasError(input.controlName)) {
          <div class="text-danger mt-1">Input required</div>
          }
        </div>
        }

        <!-- Dual Textboxes (HLPTXT) -->
        @if (input.controlType === 'HLPTXT') {
        <div class="col-12 col-sm-6 mb-3">
          <label class="form-label d-block">{{ input.captionName }}</label>

          <div class="d-flex gap-2">
            <input class="form-control" [formControlName]="input.controlName" />
            <input class="form-control" [formControlName]="input.controlName2" />
          </div>

          @if (hasError(input.controlName) || hasError(input.controlName2)) {
          <div class="text-danger mt-1">Input required</div>
          }
        </div>
        }

        <!-- Dual Datepickers (DTP2) -->
        @if (input.controlType === 'DTP2') {
        <div class="col-12 mb-3">
          <label class="form-label d-block">{{ input.captionName }}</label>

          <div class="row g-2">

            <!-- Left Date -->
            <div class="col-12 col-sm-6">
              <mat-form-field class="fullwidth" appearance="outline">

                <input matInput [min]="minDate" [max]="maxDate" [formControlName]="input.controlName"
                  [matDatepicker]="pickerLeft" placeholder="Choose a date" />

                <mat-datepicker-toggle matSuffix [for]="pickerLeft"></mat-datepicker-toggle>
                <mat-datepicker #pickerLeft></mat-datepicker>

              </mat-form-field>
            </div>

            <!-- Right Date -->
            <div class="col-12 col-sm-6">
              <mat-form-field class="fullwidth" appearance="outline">

                <input matInput [min]="minDate" [max]="maxDate" [formControlName]="input.controlName2"
                  [matDatepicker]="pickerRight" placeholder="Choose a date" />

                <mat-datepicker-toggle matSuffix [for]="pickerRight"></mat-datepicker-toggle>
                <mat-datepicker #pickerRight></mat-datepicker>

              </mat-form-field>
            </div>

          </div>
        </div>
        }

        <!-- Checkbox -->
        @if (input.controlType === 'CHK') {
        <div class="col-12 col-sm-6 mb-3">
          <label class="form-label">{{ input.captionName }}</label>
          <div class="form-check">
            <input class="form-check-input" type="checkbox" [id]="'chk_'+i" [formControlName]="input.controlName" />
            <label class="form-check-label" [for]="'chk_'+i">
              {{ input.captionName }}
            </label>
          </div>
        </div>
        }

        }
        }
      </div>


    </div>
  </div>
  <!-- Buttons -->
  <div class="row mt-3">
    <div class="col-12 d-flex justify-content-center gap-2">
      <button class="btn btn-primary" type="submit" [disabled]="form.invalid">
        {{ buttonName || 'View' }}
      </button>

      @if (ShowID > 0) {
      <button class="btn btn-secondary" type="button" (click)="configureReport()">
        Configure
      </button>
      }
    </div>
  </div>
</form>

} @else {
<!-- <form [formGroup]="form" class="modal-body  col-sm-12 form-group" (submit)="submitForm(); ">
        <ng-template ngFor let-input [ngForOf]="formData">
            <ng-container [ngSwitch]="input.controlType">
                <ng-template [ngSwitchCase]="'Hidden'">
                    <div style="display:none; " class="form-group col-sm-12">
    
                        <input class="form-control" [formControlName]="input.controlName" type="hidden" [value]="input.selectedValue" />
    
                    </div>
                </ng-template>
                <ng-template [ngSwitchCase]="'TXT'">
                    <br>
                    <div class="form-group col-sm-6">
    
                        <label class="col-sm-4" [for]="input.controlName"> {{input.captionName}}</label>
                        <div class="col-sm-8 fullwidth">
                            <input class="form-control" [placeholder]="input.placeholder" [formControlName]="input.controlName" type="text" [value]="input.selectedValue" [name]="input.controlName" [required]="input.validators.required" [minlength]="input.validators.minlength" [maxlength]="input.validators.maxlength"
                            />
                            <div class=" error" *ngIf="form.get(input.controlName).invalid && (form.get(input.controlName).dirty || form.get(input.controlName).touched)">
                                <div *ngIf="form.get(input.controlName).errors.required">
                                    Input required
                                </div>
                                <div *ngIf="form.get(input.controlName).errors.minlength">
                                    Minimum length is {{input.validators.minlength}}
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-template>
    
                <ng-template [ngSwitchCase]="'SHLP'">
                    <br>
                    <div class="form-group col-sm-6">
                        <label class="col-sm-4" [for]="input.controlName"> {{input.captionName}}</label>
                        <div *ngIf="input.controlName == 'Flow'" class="col-sm-8 fullwidth">
                            <ng-select [items]="input.Options" [clearable]="false" [multiple]="false" [formControlName]="input.controlName" bindLabel="optionName" [selectableGroup]="true" [closeOnSelect]="true" bindValue="value" [(ngModel)]="PassFlow">
                                <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                    {{item.optionName}}
                                </ng-template>
                            </ng-select>
                        </div>
                        <div *ngIf="input.controlName == 'HLPNoticeType'" class="col-sm-8 fullwidth">
                            <ng-select [items]="input.Options" [clearable]="false" [multiple]="false" [formControlName]="input.controlName" bindLabel="optionName" [selectableGroup]="true" [closeOnSelect]="true" bindValue="value" [(ngModel)]="PassStatus">
                                <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                    {{item.optionName}}
                                </ng-template>
                            </ng-select>
                        </div>
                        <div *ngIf="input.controlName != 'Flow' && input.controlName != 'HLPNoticeType'" class="col-sm-8 fullwidth">
                            <ng-select [items]="input.Options" [clearable]="false" [multiple]="false" [formControlName]="input.controlName" bindLabel="optionName" [selectableGroup]="true" [closeOnSelect]="true" bindValue="value" [(ngModel)]="input.selectedValue">
                                <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                    {{item.optionName}}
                                </ng-template>
                            </ng-select>
                        </div>
                    </div>
                </ng-template>
    
                <ng-template [ngSwitchCase]="'HLP'">
                    <div class="form-group col-sm-6">
                        <label class="col-sm-4" [for]="input.controlName"> {{input.captionName}}</label>
                        <div class="col-sm-8 fullwidth">
                            <ng-select [items]="input.Options" [clearable]="false" [multiple]="true" [formControlName]="input.controlName" bindLabel="optionName" [selectableGroup]="true" [closeOnSelect]="true" bindValue="value" [(ngModel)]="input.selectedValue3">
                                <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                    {{item.optionName}}
                                </ng-template>
                            </ng-select>
                        </div>
                        <br><br><br>
                    </div>
                </ng-template>
                <ng-template [ngSwitchCase]="'HLPTXT'">
                    <div class="form-group col-sm-6">
                        <label class="col-sm-4"> {{input.captionName}}</label>
                        <input class="col-sm-3 form-control" style="margin-left:5%;" [formControlName]="input.controlName" type="text" [value]="input.selectedValue" [name]="input.controlName" [required]="input.validators.required" [minlength]="input.validators.minlength" [maxlength]="input.validators.maxlength"
                        />
                        <input class="col-sm-3 form-control" style="margin-left:7%;" [formControlName]="input.controlName2" type="text" [value]="input.selectedValue2" [name]="input.controlName2" [required]="input.validators.required" [minlength]="input.validators.minlength"
                            [maxlength]="input.validators.maxlength" />
    
                    </div>
    
                </ng-template>
                <ng-template [ngSwitchCase]="'DTP2'">
                    <div class="form-group col-sm-6">
                        <label class=" col-sm-4"> {{input.captionName}}</label>
                        <mat-form-field class="fullwidth col-sm-4">
                            <input matInput  [min]="minDate" [formControlName]="input.controlName" [max]="maxDate" [matDatepicker]="picker" placeholder="Choose a date">
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>
                        </mat-form-field>
                        <mat-form-field class="fullwidth col-sm-4">
                            <input matInput  [min]="minDate" [formControlName]="input.controlName2" [max]="maxDate" [matDatepicker]="picker1" placeholder="Choose a date">
                            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                            <mat-datepicker #picker1></mat-datepicker>
                        </mat-form-field>
                    </div>
    
                </ng-template>
    
                <ng-template [ngSwitchCase]="'CHK'">
                    <br>
                    <div class="form-group col-sm-6">
                        <label class="col-sm-4"> {{input.controlType}}</label>
                        <input class="col-sm-1 " type="checkbox" [checked]="input.selectedValue" [formControlName]="input.controlName" />
                        <div class="col-sm-7">&nbsp;</div>
                    </div>
                </ng-template>
            </ng-container>
        </ng-template>
        <div><br><br>
            <div class="col-sm-12">&nbsp;</div>
            <div class="form-group">
                <div class="col-sm-3">&nbsp;</div>
                <input class="btn btn-primary col-sm-2" type="submit" value={{buttonName}}>
                <div class="col-sm-1">&nbsp;</div>
                <div class="col-sm-2" *ngIf="(this.ShowID>0)"><button type="button" class="btn btn-primary col-sm-12" (click)="configureReport(); ">Configure</button></div>
                <div class="col-sm-3"></div>
            </div>
        </div>
        <div class="form-group mt-2" style="display:none;">
            <div class="form-check">
                <input type="checkbox" name="autoClose" id="autoClose" class="form-check-input" checked=true [(ngModel)]="options.autoClose">
                <label for="autoClose">Auto close alert after three seconds</label>
            </div>
    
        </div>
        <div class="jumbotron p-4">
            <div class="container text-center col-sm-3 alertCss">
                <app-alert></app-alert>
                <router-outlet></router-outlet>
            </div>
        </div>
    </form> -->
}